import DTO from './DTO';

class IntervalDTO extends DTO {
  constructor(params, isValidInit) {
    const attributes = [
      {
        name: 'id',
        type: String,
        validators: {},
        labelKey: 'subs.id',
      },
      {
        name: 'subscription_id',
        type: String,
        validators: [],
        labelKey: 'interval.subscription_id',
      },
      {
        name: 'start_at',
        type: String,
        validators: [],
        labelKey: 'interval.start_at',
      },
      {
        name: 'end_at',
        type: String,
        validators: [],
        labelKey: 'interval.end_at',
      },
      {
        name: 'payment_id',
        type: String,
        validators: [],
        labelKey: 'interval.payment_id',
      },
    ];
    super(attributes, params, isValidInit);
  }
}

export default IntervalDTO;
